// Spielzustand und Auswertung von Bedingungen/Regeln – rein, ohne DOM, testbar.
import type { Cond, Rule } from './types.ts';

export interface GameState {
  chapter: string;
  scene: string;
  pos?: { x: number; y: number };
  flags: Record<string, string | number | boolean>;
  inventory: string[];
  seenQuestions: string[];
  playtimeMs: number;
  updatedAt: number;
}

export function newState(chapter: string, scene: string): GameState {
  return { chapter, scene, flags: {}, inventory: [], seenQuestions: [], playtimeMs: 0, updatedAt: Date.now() };
}

export function check(c: Cond | undefined, s: GameState): boolean {
  if (!c) return true;
  if ('all' in c) return c.all.every((x) => check(x, s));
  if ('any' in c) return c.any.some((x) => check(x, s));
  if ('not' in c) return !check(c.not, s);
  if ('has' in c) return s.inventory.includes(c.has);
  const v = s.flags[c.flag];
  if (c.min !== undefined) return Number(v ?? 0) >= c.min;
  if (c.is === undefined) return !!v;
  return v === c.is;
}

export function pickRule(rules: Rule[] | undefined, s: GameState): Rule | undefined {
  return rules?.find((r) => check(r.if, s));
}
